import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import n from "../../../../../Color.js";
var r = {
  kind: "null"
},
    e = {
  kind: "number"
},
    t = {
  kind: "string"
},
    i = {
  kind: "boolean"
},
    o = {
  kind: "color"
},
    f = {
  kind: "object"
},
    u = {
  kind: "value"
};

function a(n, r) {
  return {
    kind: "array",
    itemType: n,
    n: r
  };
}

var y = [r, e, t, i, o, f, a(u)];

function k(n) {
  if ("array" === n.kind) {
    var _r = k(n.itemType);

    return "number" == typeof n.n ? "array<".concat(_r, ", ").concat(n.n, ">") : "value" === n.itemType.kind ? "array" : "array<".concat(_r, ">");
  }

  return n.kind;
}

function l(y) {
  if (null === y) return r;
  if ("string" == typeof y) return t;
  if ("boolean" == typeof y) return i;
  if ("number" == typeof y) return e;
  if (y instanceof n) return o;

  if (Array.isArray(y)) {
    var _n;

    var _iterator = _createForOfIteratorHelper(y),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _r2 = _step.value;

        var _e = l(_r2);

        if (_n) {
          if (_n !== _e) {
            _n = u;
            break;
          }
        } else _n = _e;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return a(_n || u, y.length);
  }

  return "object" == typeof y ? f : u;
}

function c(n, r) {
  if ("array" === r.kind) return "array" === n.kind && (0 === n.n && "value" === n.itemType.kind || c(n.itemType, r.itemType)) && ("number" != typeof r.n || r.n === n.n);

  if ("value" === r.kind) {
    var _iterator2 = _createForOfIteratorHelper(y),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _e2 = _step2.value;
        if (c(n, _e2)) return !0;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return r.kind === n.kind;
}

function d(r) {
  if (null === r) return "";
  var e = typeof r;
  return "string" === e ? r : "number" === e || "boolean" === e ? String(r) : r instanceof n ? r.toString() : JSON.stringify(r);
}

export { i as BooleanType, o as ColorType, r as NullType, e as NumberType, f as ObjectType, t as StringType, u as ValueType, a as arrayType, l as getType, c as matchType, k as typeToString, d as valueToString };